import { useSelector } from "react-redux";
import { useRestAPI } from "./axiosAPI";
import { RootState } from "src/redux/store";
import { useCentralAPI } from "./centralAPI";
import { useQuery } from "@tanstack/react-query";
import { Team } from "src/types";

export function useActiveProjectTeamsAPI({
    retryCount,
    trigger = true
}: {
    retryCount?: number,
    trigger?: boolean
}) {
    const api = useRestAPI()
    const userData = useSelector((state: RootState) => state.user.adminDetails)
    const {
        centralData,
        isFetching:isFetchingCentralData,
        isFetched:isFetchedCentralData,
        isError:isErrorCentralData,
        error:errorCentralData
    } = useCentralAPI({
        trigger: false
    });


    async function loadteamsUnderProject({organizationName, projectId }: {organizationName: string, projectId: string }) {

        type ActiveProjectTeamsResponse = {
            value: {
                id: string,
                name: string,
                url: string,
                description: string,
                identityUrl: string,
                projectName: string,
                projectId: string
            }[],
            count: number
        }

        const response = await api.get<ActiveProjectTeamsResponse>({
            url: `https://dev.azure.com/${organizationName}/_apis/projects/${projectId}/teams`,
            mode: 'protected',
            params: {
                'api-version': '7.1'
            },
        })
        if (response.success === false) {
            throw response.msg
        }
        return response.value
    }
    
    async function loadMembersUnderTeam({organizationName, projectId,teamId }: {organizationName: string, projectId: string, teamId: string }) {

        type TeamMembersListResponse = {
            value: {
                identity: {
                    displayName: string,
                    url: string,
                    _links: {
                        avatar: {
                            href: string,
                        },
                    },
                    id: string,
                    uniqueName: string,
                    imageUrl: string,
                    descriptor: string,
                },
            }[],
            count: number
        }

        const response = await api.get<TeamMembersListResponse>({
            url: `https://dev.azure.com/${organizationName}/_apis/projects/${projectId}/teams/${teamId}/members`,
            mode: 'protected',
            params: {
                'api-version': '7.1'
            },
        })
        if (response.success === false) {
            throw response.msg
        }
        return response.value
    }

    const {
        data: ActiveProjectTeams,
        isLoading,
        isError,
        refetch: refetchActiveProjectTeams,
        isFetching,
        isFetched,
        error
    } = useQuery({
        queryKey: ['active-project-teams'],
        queryFn: async (): Promise<Team[]> => {

            let Teams : Team[] = []

            //filter active projects
            const AcitveProjects = centralData?.Projects.filter((project) => project.projectStatus === 'inProgress')||[]
            

            //finding teams in each projects
             await Promise.all(AcitveProjects.map(async (project) => {

                const organization = centralData?.Organizations.find((organization) => organization.accountId === project.organization_accountId)

                const teams = await loadteamsUnderProject({organizationName: organization?.accountName||'', projectId: project.id})
                
                teams.map(
                    team=>{

                        Teams.push(
                            {
                                ...team,
                                organization_accountId:organization?.accountId||'',
                                usersIds:[]
                            }
                        )
                            
                    }
                )

            }))

            //load users under teams
            await Promise.all(Teams.map(async (team) => {
                const organization = centralData?.Organizations.find((organization) => organization.accountId === team?.organization_accountId)
                const members = await loadMembersUnderTeam({organizationName: organization?.accountName||'', projectId: team?.projectId||'', teamId: team.id})
                team.usersIds = members.map((member) => member.identity.id)
            }))


            return Teams

            

        },
        refetchOnWindowFocus: false,
        retry: retryCount,
        enabled: trigger

    })

    return {
        isLoading,
        isError,
        ActiveProjectTeams,
        refetch: refetchActiveProjectTeams,
        isFetching,
        isFetched,
        error
    }

}